import { render, staticRenderFns } from "./sos_dashboard.vue?vue&type=template&id=5e6c5886&scoped=true&"
import script from "./sos_dashboard.vue?vue&type=script&lang=js&"
export * from "./sos_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./sos_dashboard.vue?vue&type=style&index=0&id=5e6c5886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c5886",
  null
  
)

export default component.exports